export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-store-2-line' },
  { id: 'plush', name: '嫩小兔玩偶', slug: 'plush', icon: 'ri-heart-line' },
  { id: 'merch', name: '嫩小兔周边', slug: 'merch', icon: 'ri-shirt-line' },
  { id: 'collab', name: '联名产品', slug: 'collab', icon: 'ri-star-line' },
  { id: 'giftbox', name: '限定礼盒', slug: 'giftbox', icon: 'ri-gift-line' },
];

export const products = [
  {
    id: 'p1',
    name: '软绵绵嫩小兔抱枕玩偶',
    category: 'plush',
    price: '¥89',
    image: 'https://readdy.ai/api/search-image?query=A%20super%20cute%20soft%20plush%20rabbit%20pillow%20toy%20with%20long%20floppy%20ears%20and%20round%20pink%20cheeks%2C%20pastel%20pink%20and%20cream%20white%20color%20scheme%2C%20kawaii%20Japanese%20style%2C%20soft%20fabric%20texture%20visible%2C%20clean%20minimal%20white%20studio%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%20style%2C%20high%20detail%2C%20gentle%20shadows&width=800&height=800&seq=product-plush-01&orientation=squarish',
    description: '超柔短毛绒面料，填充饱满，手感软糯如云朵。36cm黄金尺寸，可抱可枕，是嫩小兔粉丝必入的治愈系单品。',
    tags: ['热卖', '新品'],
    isNew: true,
    isHot: true,
  },
  {
    id: 'p2',
    name: '嫩小兔梦幻星空限定玩偶',
    category: 'plush',
    price: '¥128',
    image: 'https://readdy.ai/api/search-image?query=A%20dreamy%20star-themed%20plush%20rabbit%20toy%20with%20sparkling%20star%20patterns%20on%20ears%2C%20lavender%20and%20soft%20blue%20gradient%20fur%2C%20embroidery%20star%20details%2C%20sitting%20pose%2C%20kawaii%20expression%20with%20big%20sparkly%20eyes%2C%20clean%20minimal%20white%20studio%20background%20with%20soft%20warm%20lighting%2C%20professional%20product%20photography&width=800&height=800&seq=product-plush-02&orientation=squarish',
    description: '2026梦幻星空系列，渐变紫蓝色绒毛搭配立体星星刺绣，限时发售，每只都有独一无二的星空编号。',
    tags: ['限定', '新品'],
    isNew: true,
    isLimited: true,
  },
  {
    id: 'p3',
    name: '嫩小兔迷你盲盒系列（第3弹）',
    category: 'plush',
    price: '¥59',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20six%20miniature%20blind%20box%20plush%20rabbit%20figures%20in%20different%20pastel%20colors%2C%20each%20with%20unique%20outfits%20and%20expressions%2C%20arranged%20in%20a%20row%2C%20kawaii%20collectible%20style%2C%20Japanese%20gachapon%20inspired%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-plush-03&orientation=squarish',
    description: '第3弹盲盒来啦！6款常规+2款隐藏，每款嫩小兔都有独特装扮。收集控的最爱，你能否开出隐藏款？',
    tags: ['盲盒', '热卖'],
    isHot: true,
  },
  {
    id: 'p4',
    name: '嫩小兔毛绒双肩包',
    category: 'merch',
    price: '¥159',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20furry%20backpack%20shaped%20like%20a%20rabbit%20with%20floppy%20ears%20and%20a%20pink%20bow%2C%20pastel%20pink%20and%20cream%20color%2C%20front%20zipper%20pocket%2C%20adjustable%20straps%2C%20kawaii%20fashion%20accessory%2C%20clean%20minimal%20white%20studio%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-merch-01&orientation=squarish',
    description: '萌趣与实用兼得！毛绒兔耳造型双肩包，大容量主仓+前袋设计，日常出行回头率满分。',
    tags: ['周边', '新品'],
    isNew: true,
  },
  {
    id: 'p5',
    name: '嫩小兔限定保温杯',
    category: 'merch',
    price: '¥99',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20stainless%20steel%20thermal%20bottle%20with%20rabbit%20ear%20lid%20design%2C%20pastel%20pink%20matte%20finish%2C%20kawaii%20rabbit%20face%20engraving%2C%20compact%20size%20350ml%2C%20clean%20white%20studio%20background%2C%20soft%20warm%20lighting%2C%20minimal%20product%20photography&width=800&height=800&seq=product-merch-02&orientation=squarish',
    description: '316不锈钢内胆，12小时保温。兔耳杯盖设计，喝水也要可可爱爱。配专属嫩小兔杯套。',
    tags: ['限定'],
    isLimited: true,
  },
  {
    id: 'p6',
    name: '嫩小兔×薄荷糖联名T恤',
    category: 'collab',
    price: '¥139',
    image: 'https://readdy.ai/api/search-image?query=A%20white%20cotton%20t-shirt%20with%20cute%20rabbit%20and%20mint%20candy%20collaboration%20graphic%20print%2C%20oversized%20fit%2C%20kawaii%20illustration%20style%20with%20pastel%20mint%20green%20and%20pink%20accents%2C%20flat%20lay%20on%20white%20background%2C%20soft%20lighting%2C%20fashion%20product%20photography&width=800&height=800&seq=product-collab-01&orientation=squarish',
    description: '嫩小兔首次跨界联名！携手人气插画师"薄荷糖"，清新薄荷绿搭配软萌兔兔，限量1000件。',
    tags: ['联名', '限定'],
    isLimited: true,
  },
  {
    id: 'p7',
    name: '嫩小兔×草莓喵喵联名帆布袋',
    category: 'collab',
    price: '¥79',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20canvas%20tote%20bag%20with%20rabbit%20and%20cat%20collaboration%20illustration%2C%20strawberry%20and%20cream%20color%20palette%2C%20kawaii%20co-branded%20design%2C%20sturdy%20cotton%20material%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-collab-02&orientation=squarish',
    description: '嫩小兔×草莓喵喵梦幻联动！可爱兔猫相遇，帆布厚实耐用，逛街通勤都萌翻全场。',
    tags: ['联名', '新品'],
    isNew: true,
  },
  {
    id: 'p8',
    name: '嫩小兔春日花园限定礼盒',
    category: 'giftbox',
    price: '¥299',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20pastel%20pink%20gift%20box%20with%20floral%20and%20rabbit%20illustrations%2C%20open%20lid%20revealing%20a%20plush%20rabbit%20keychain%20and%20scented%20candles%20and%20stickers%20inside%2C%20spring%20garden%20theme%2C%20ribbon%20detail%2C%20clean%20white%20background%2C%20soft%20lighting%2C%20luxury%20product%20photography&width=800&height=800&seq=product-gift-01&orientation=squarish',
    description: '春日花园主题礼盒：含限定玩偶钥匙扣×1、香薰蜡烛×1、兔兔贴纸套装×1、手写祝福卡，送人自用两相宜。',
    tags: ['礼盒', '限定'],
    isLimited: true,
  },
  {
    id: 'p9',
    name: '嫩小兔生日派对惊喜礼盒',
    category: 'giftbox',
    price: '¥399',
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20celebration%20gift%20box%20with%20rabbit%20theme%2C%20birthday%20party%20design%2C%20cream%20and%20pink%20color%20scheme%2C%20contains%20mini%20plush%20rabbit%20and%20accessories%2C%20confetti%20pattern%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-gift-02&orientation=squarish',
    description: '生日专属惊喜！含中号嫩小兔玩偶×1、定制蛋糕蜡烛×1、兔兔发箍×1、立体贺卡×1，让生日充满萌趣。',
    tags: ['礼盒', '热卖'],
    isHot: true,
  },
  {
    id: 'p10',
    name: '嫩小兔樱花季限定徽章套装',
    category: 'merch',
    price: '¥49',
    image: 'https://readdy.ai/api/search-image?query=A%20set%20of%20enamel%20pin%20badges%20featuring%20cute%20rabbits%20with%20cherry%20blossom%20designs%2C%20pastel%20pink%20and%20white%2C%20gold%20metal%20edges%2C%20displayed%20on%20a%20card%2C%20kawaii%20collectible%20style%2C%20clean%20white%20studio%20background%2C%20soft%20lighting&width=800&height=800&seq=product-merch-03&orientation=squarish',
    description: '樱花季限定徽章，一套5枚不同造型。珐琅工艺，金色包边，可别在包包、衣服上，每日换新造型。',
    tags: ['限定', '新品'],
    isNew: true,
    isLimited: true,
  },
  {
    id: 'p11',
    name: '嫩小兔睡眠眼罩',
    category: 'merch',
    price: '¥45',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20silk%20sleep%20eye%20mask%20with%20rabbit%20ear%20and%20face%20embroidery%2C%20pastel%20pink%20color%2C%20soft%20silky%20fabric%2C%20adjustable%20strap%2C%20folded%20neatly%2C%20clean%20white%20studio%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-merch-04&orientation=squarish',
    description: '真丝面料睡眠眼罩，兔耳立体造型，遮光透气。戴上它，每天都被嫩小兔守护着入眠。',
    tags: ['周边'],
  },
  {
    id: 'p12',
    name: '嫩小兔表情包贴纸大全',
    category: 'merch',
    price: '¥19',
    image: 'https://readdy.ai/api/search-image?query=A%20full%20sheet%20of%20cute%20rabbit%20emoji%20stickers%20with%20various%20expressions%2C%20kawaii%20illustration%20style%2C%20pastel%20colors%2C%20die-cut%20design%2C%20waterproof%20vinyl%2C%20clean%20white%20background%2C%20soft%20lighting%2C%20product%20photography&width=800&height=800&seq=product-merch-05&orientation=squarish',
    description: '28款嫩小兔表情包贴纸，防水耐磨，贴在手账、手机壳、电脑上都超可爱。萌兔控的桌面必备！',
    tags: ['周边', '热卖'],
    isHot: true,
  },
];

export const featuredProductIds = ['p1', 'p2', 'p4', 'p6', 'p8', 'p9'];